module.exports = __webpack_public_path__ + "img/DE00847.8e48fa7d.png";